import { render, staticRenderFns } from "./checkName.vue?vue&type=template&id=1408b9d8&scoped=true&"
import script from "./checkName.vue?vue&type=script&lang=js&"
export * from "./checkName.vue?vue&type=script&lang=js&"
import style0 from "./checkName.vue?vue&type=style&index=0&id=1408b9d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1408b9d8",
  null
  
)

export default component.exports